module.exports = __webpack_public_path__ + "./fonts/montserrat-latin-200.444ae007121264bc1969d49b4031f9b2.woff2";